import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Income18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M12.5 6.25H13.25V8.75H12.5V10.25H14.75V4.75H12.5V6.25Z'
      fill='currentColor'
    />
    <path
      d='M7.75 8.75H8.5V10.25L6.25 10.25L6.25 4.75L8.5 4.75L8.5 6.25H7.75L7.75 8.75Z'
      fill='currentColor'
    />
    <path
      d='M11.5 7.5C11.5 8.05228 11.0523 8.5 10.5 8.5C9.94771 8.5 9.5 8.05228 9.5 7.5C9.5 6.94771 9.94771 6.5 10.5 6.5C11.0523 6.5 11.5 6.94771 11.5 7.5Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.25 2.25H17.75V12.75H3.25V2.25ZM4.75 3.75V11.25H16.25V3.75H4.75Z'
      fill='currentColor'
    />
    <path d='M1.75 14.25V6H0.25V15.75H16V14.25H1.75Z' fill='currentColor' />
  </Svg>
);

Income18.displayName = 'Income18';
export default Income18;
